import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbText } from '../../types/pbBlocks';
import { getAdvanced, parseStyleString } from '../utils';

export type TextType = ContentTypeObject & PbText;

/**
 * Aggregates the configuration of a text element.
 * @param node
 */
export function textConfigAggregator(node: CustomHtmlElement): TextType {
    const style = parseStyleString(node?.attributes.style);

    return {
        ...getAdvanced(node, style),
        content: node.innerHTML,
        uniqueID: node.attributes['data-pb-style'],
    };
}
